import type {ReactNode} from 'react';
import {Box, Button, type ButtonProps, type SxProps, type Theme} from '@mui/material';
import {COLORS} from '~/style/colors-ts';
import { Stack } from "@mui/system";

export type SegmentedControlProps = {
    /** Button labels (text or icons) in display order. */
    labels: ReactNode[];
    /** Index of the currently selected button. */
    value: number;
    onChange: (index: number) => void;
    disabled?: boolean;
    className?: string;
    sx?: SxProps<Theme>;
    buttonProps?: ButtonProps;
};

const rootSx: SxProps<Theme> = {
    borderRadius: '8px',
    backgroundColor: 'rgba(226, 226, 233, 1)',
    p: '2px',
    gap: '4px',
};

const getButtonSx = (selected: boolean): SxProps<Theme> => ({
    // flex: 1,
    // minWidth: 0,
    fontSize: '12px',
    color: COLORS.text.primary,
    px: 1,
    py: 0.5,
    ...(selected
        ? {
            background: COLORS.white[900],
        }
        : {
            background: 'transparent',
        }),
});

export function SegmentedControl({
                                     labels,
                                     value,
                                     onChange,
                                     disabled = false,
                                     className,
                                     buttonProps,
                                     sx,
                                 }: SegmentedControlProps) {
    return (
        <Stack direction="row" className={className} sx={[rootSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
            {labels.map((label, index) => (
                <Button
                    key={index}
                    size="small"
                    color="inherit"
                    disabled={disabled}
                    onClick={() => onChange(index)}
                    sx={getButtonSx(index === value)}
                    {...buttonProps}
                >
                    {label}
                </Button>
            ))}
        </Stack>
    );
}
